<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="6"
		/>
		<p>نتیجه ارزیابی</p>


		<p>{{ val.value.comment }}</p>
		<btn 
		type="orange" 
		:img="require('../../assets/img/hourglass.svg')" 
		style="margin-top: 33px;"
		text="در دست بررسی" 
		/>
		<p class="mt-4">
			پروفایل شما توسط کارشناسان ما در حال بررسی است. از شکیبایی شما متشکریم.
			<br>
			<br>
			<br>
			<br>
			<br>
			<br>
			<br>
			<br>
		</p>
	</div>
</template>

<script>
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import btn from "../../UI/button/btn.vue";
	

	export default {
		name: 'wait_signup',
		data(){
			return {
			}
		},
		components: {
			btn,
			multi_step_progress,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){

		},
		methods:{
		}
	}
</script>
<style>

</style>
